// extracted by mini-css-extract-plugin
export default {"wrapper":"types_wrapper__kx77f"};